import { render, staticRenderFns } from "./StepReview.vue?vue&type=template&id=750c37de&scoped=true&"
import script from "./StepReview.vue?vue&type=script&lang=js&"
export * from "./StepReview.vue?vue&type=script&lang=js&"
import style0 from "./StepReview.vue?vue&type=style&index=0&id=750c37de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750c37de",
  null
  
)

export default component.exports